import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const progressVariants = cva('relative h-2 w-full overflow-hidden', {
  variants: {
    tone: {
      default: 'rounded-full bg-primary/20',
      // Pazarlama sayfaları (mkt-* token'ları): gri iz üzerinde canlı / açık mavi dolum
      mktStrong: 'rounded-[4px] bg-mkt-track',
      mktSoft: 'rounded-[4px] bg-mkt-track',
      mktDeep: 'rounded-[4px] bg-mkt-track',
      success: 'rounded-full bg-primary/20',
      amber: 'rounded-full bg-primary/20',
      red: 'rounded-full bg-primary/20',
    },
  },
  defaultVariants: {
    tone: 'default',
  },
});

const progressIndicatorVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    tone: {
      default: 'bg-primary',
      mktStrong: 'bg-mkt-blue',
      mktSoft: 'bg-mkt-blue-light',
      mktDeep: 'bg-mkt-blue-deep',
      success: 'bg-emerald-500',
      amber: 'bg-amber-500',
      red: 'bg-red-500',
    },
  },
  defaultVariants: {
    tone: 'default',
  },
});

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & VariantProps<typeof progressVariants>
>(({ className, value, tone, ...props }, ref) => (
  <ProgressPrimitive.Root ref={ref} className={cn(progressVariants({ tone }), className)} {...props}>
    <ProgressPrimitive.Indicator
      className={progressIndicatorVariants({ tone })}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;
export { Progress };
